import { render } from "./LotteryStat.vue?vue&type=template&id=2bc5785e"
import script from "./LotteryStat.vue?vue&type=script&lang=js"
export * from "./LotteryStat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__